<section id="how">
  <div class="container">
    <div class="text-center" appReveal>
      <div class="sec-label">Cómo funciona</div>
      <h2 class="sec-title" style="max-width:640px;margin:0 auto 1rem">Implementación en 3 pasos</h2>
      <p class="sec-sub mx-auto">Nuestro equipo te acompaña durante todo el proceso.</p>
    </div>
    <div class="row g-4 mt-4">
      <div class="col-md-4">
        <div class="how-card text-center" appReveal>
          <div class="step-circle mx-auto">01</div>
          <h4>Elige tu plan</h4>
          <p>Básico, Premium o Plata según las necesidades de tu privada.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="how-card text-center" appReveal>
          <div class="step-circle mx-auto">02</div>
          <h4>Configuración</h4>
          <p>Configuramos la plataforma con datos, usuarios y amenidades.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="how-card text-center" appReveal>
          <div class="step-circle mx-auto">03</div>
          <h4>Operación</h4>
          <p>Tu fraccionamiento opera digitalmente con soporte continuo.</p>
        </div>
      </div>
    </div>
  </div>
</section>
